<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
  data: () => ({
    active: false,
  }),
  methods: {
    handlerClick() {
      this.active = !this.active;
    },
  },
};
</script>
<template>
  <div
    class="template-filter"
  >
    <i class="el-icon-search"></i>
    <input
      type="text"
      placeholder="Поиск и фильтр"
      @click="handlerClick"
    >
    <div class="template-filter__popover" v-if="active">
      <div class="template-filter__kit">
        <div class="template-filter__item is-active">Все</div>
        <div class="template-filter__item">Новый фильтр</div>
        <div class="template-filter__space"></div>
        <BtnPrimary full>Найти</BtnPrimary>
      </div>
      <div class="template-filter__form">
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .template-filter {
    display: flex;
    font-size: 18px;
    align-items: center;
    position: relative;
    height: 100%;
    width: 100%;

    i {
      font-size: 18px;
    }

    input {
      border: none;
      outline: none;
      padding: 0 8px;
      font-size: 16px;
      line-height: 24px;
    }

    &__popover {
      position: absolute;
      border-top: 1px solid #dddddd;
      font-size: 14px;
      top: 66px;
      left: 0;
      right: 0;
      background: #f5f5f5;
      box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
      display: flex;
      height: 60vh;
    }

    &__kit {
      background: #ffffff;
      width: 300px;
      padding: 16px;
      flex-shrink: 0;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }

    &__item {
      padding: 6px 8px;
      margin-bottom: 8px;
      border-radius: 4px;

      &:hover {
        background: #1b2f3f11;
        cursor: pointer;
      }

      &.is-active {
        background: #1b2f3f99;
        color: #ffffff;
      }
    }

    &__form {
      flex: 1;
      overflow: auto;
    }

    &__space {
      flex: 1;
    }
  }

  @media (max-height: 600px) {
    .template-filter {
      &__popover {
        top: 44px;
      }
    }
  }

  @media (max-width: 1600px) {
    .template-filter {
      position: static;
    }
  }
</style>
